import { DASHBOARD } from "../actionTypes";

const initialState = {
    arrLivePulse: [],
    // arrLivePulseBse: []

};

const livePulseReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case DASHBOARD.GET_LIVE_PULSE:
            return {
                ...state,
                arrLivePulse: actions?.payload
                // [
                //     { id: 1, company_name: 'TCS', company_age: 'NEW', support: 'Broken S1 Support', date: '29 May \' 20 12:34:20 PM', price: '1071.70', profit_loss: '-37.60', percentage: '-0.23%' },
                //     { id: 2, company_name: 'RELIANCE', company_age: 'NEW', support: 'High of the Day', date: '29 May \' 20 12:34:20 PM', price: '1071.70', profit_loss: '-46.60', percentage: '-1.73%' },
                //     { id: 3, company_name: 'BHARTIARTL', company_age: null, support: 'Broken S1 Suppor..', date: '29 May \' 20 12:34:20 PM', price: '1071.70', profit_loss: '+37.8', percentage: '+1.53%' },
                //     { id: 4, company_name: 'TATAMOTORS', company_age: null, support: 'Broken S1 Suppor..', date: '29 May \' 20 12:34:20 PM', price: '1071.70', profit_loss: '+37.8', percentage: '+1.53%' },
                //     { id: 5, company_name: 'TCS', company_age: 'NEW', support: 'Broken S1 Support', date: '29 May \' 20 12:34:20 PM', price: '1071.70', profit_loss: '-37.60', percentage: '-0.23%' },
                //     { id: 6, company_name: 'RELIANCE', company_age: 'NEW', support: 'High of the Day', date: '29 May \' 20 12:34:20 PM', price: '1071.70', profit_loss: '-46.60', percentage: '-1.73%' },
                //     { id: 7, company_name: 'BHARTIARTL', company_age: null, support: 'Broken S1 Suppor..', date: '29 May \' 20 12:34:20 PM', price: '1071.70', profit_loss: '+37.8', percentage: '+1.53%' },
                //     { id: 8, company_name: 'TATAMOTORS', company_age: null, support: 'Broken S1 Suppor..', date: '29 May \' 20 12:34:20 PM', price: '1071.70', profit_loss: '+37.8', percentage: '+1.53%' },
                //     { id: 9, company_name: 'TCS', company_age: 'NEW', support: 'Broken S1 Support', date: '29 May \' 20 12:34:20 PM', price: '1071.70', profit_loss: '-37.60', percentage: '-0.23%' },
                //     { id: 10, company_name: 'RELIANCE', company_age: 'NEW', support: 'High of the Day', date: '29 May \' 20 12:34:20 PM', price: '1071.70', profit_loss: '-46.60', percentage: '-1.73%' },
                //     { id: 11, company_name: 'BHARTIARTL', company_age: null, support: 'Broken S1 Suppor..', date: '29 May \' 20 12:34:20 PM', price: '1071.70', profit_loss: '+37.8', percentage: '+1.53%' },
                //     { id: 12, company_name: 'TATAMOTORS', company_age: null, support: 'Broken S1 Suppor..', date: '29 May \' 20 12:34:20 PM', price: '1071.70', profit_loss: '+37.8', percentage: '+1.53%' },
                // ]
            };

        // case DASHBOARD.GET_LIVE_PULSE_BSE:
        //     return {
        //         ...state,
        //         arrLivePulseBse: actions?.payload}

        default:
            return state;
    }
};
export default livePulseReducer;